export default "__VITE_ASSET__e4KNQ9jK6Qxf3UTzHQBM_Q__"